import { mapMutations } from 'vuex';

export default {
  props: {
    /**
     * The field name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The field value.
     */
    value: {
      required: false,
      default: '',
    },

    /**
     * The options for the select field. Should be a array of objects with id and name attributes.
     */
    options: {
      type: Array,
      required: false,
      default: () => [],
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    /**
     * option label separator
     */
    separator: {
      type: String,
      required: false,
    },

    /**
     * trigger mode of expanding options (click/hover)
     */
    expandTrigger: {
      type: String,
      required: false,
    },

    /**
     * debounce delay when typing filter keyword, in milliseconds
     */
    debounce: {
      type: Number,
      required: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input has error.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * If the input is disabled.
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * If user can filter options.
     */
    multiple: {
      type: Boolean,
      default: false,
    },
    /**
     * If user can filter options.
     */
    filterable: {
      type: Boolean,
      default: true,
    },

    /**
     * If it is loading options from server.
     */
    loading: {
      type: Boolean,
      default: false,
    },

    /**
     * The component to add another option.
     */
    quickForm: {
      type: Object,
      required: false,
    },
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * This method will be called when input event is fired.
     *
     * @param  {String} name    The field name.
     */
    onInput(name) {
      return (value) => {
        this.$emit('change', name, value);
      };
    },
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h    Mandatory for vue to render JSX.
   */
  /* eslint no-console: ["error", { allow: ["log", "error"] }] */
  // eslint-disable-next-line
  render(h) {
    let value = this.value;
    if (typeof this.value === 'string' && this.value === '') {
      value = [];
    }
    const props = {
      multiple: this.multiple,
      expandTrigger: this.expandTrigger,
    };
    const cascader = (
      <el-cascader
        value={value}
        loading={this.loading}
        filterable={this.filterable}
        disabled={this.disabled}
        onInput={this.onInput(this.name)}
        options={this.options}
        props={props}
        name={this.name}
        placeholder={
          this.translation
            ? this.$t(`${this.translation}.placeholder`)
            : this.name
        }
      ></el-cascader>
    );

    if (!this.insideForm) {
      return cascader;
    }

    let label = null;
    if (this.hasLabel) {
      label = this.translation
        ? this.$t(`${this.translation}.label`)
        : this.name;
    }

    return (
      <el-form-item error={this.error} label={label}>
        {cascader}
      </el-form-item>
    );
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/cascader/cascader.jsx